import { useFormik } from 'formik';
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { operateSchema } from '../../../constant-value/schema';
import { OPERATE_INSERT } from '../../../constant-value';
import { toast } from 'react-toastify';
import api from '../../../services/axiosConfig';
import DatePicker from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import { toEnglishDigits } from '../../../services/functions';
import DateObject from "react-date-object";


const ServiceStepThree = () => {
  const { carId, carTitle, operKindId, operKindTitle, serviceType, mtbo, unit } = useParams();
  const [calendarValue, setCalendarValue] = useState(new Date())
  const [date, setDate] = useState(null);
    const navigate = useNavigate();
    const [operate, setOperate] = useState({
      operKindId: operKindId,
      mtbo: parseFloat(mtbo),
      unit: unit,
      // lastDateP: '',
      lastDateG: calendarValue,
      lastKM: 0,
      // programDateP: '',
      programDateG: "",
      programKM: 0,
      remain: "0",
      remainUnit: unit,
      carId: carId,
      opTitle: operKindTitle
    });

    const beforeHandler = () => {
        navigate(-1);
      };

      const message = (message,type) => {
        if (type==='warn') {
          toast.warning(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }

      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue, // 👈 اینو اضافه کن
        setSubmitting
      } = useFormik({
        enableReinitialize: true,
        initialValues: operate,
        validationSchema: operateSchema,
        
        onSubmit: (values) => {

          // let selectedDate;
          // if (!date) {
          //   selectedDate = new DateObject({ calendar: persian, locale: persian_fa });
          // }  else {
          //   selectedDate = date;
          // }      
          let selectedDate = values.lastDateG;
          if (!selectedDate){
            message('تاریخ انجام را تعیین نمایید!','warn');
            return;
          } 
          
          // اگر DateObject نیست تبدیلش کن
          if (!(values.lastDateG instanceof DateObject)) {
            selectedDate = new DateObject(values.lastDateG);
          }

          const gregorianDate = toEnglishDigits(
            selectedDate.convert(gregorian, "en").format("YYYY-MM-DD HH:mm:ss")
          );

          const payload = {
            ...values,
            operDonDate: gregorianDate,
            lastDateG: gregorianDate
          };

          api.post(`/${OPERATE_INSERT}`, payload)
              .then((res) => {
                if (res.data.isSuccess) {
                  navigate("/all-services");
                  message(res.data.message,'success');
                } else {
                  message(res.data.message,'warn');
                }});

          // axios.post(`${BASE_URL}/${OPERATE_INSERT}`, values).then((res) => {
          //   if (res.data.isSuccess) {
          //     navigate("/all-services");
          //     message(res.data.message,'success');
          //   } else {
          //     message(res.data.message,'warn');
          //   }});
        },
      });

      const numberChangeHandler = (evt) => {
        // setFieldValue(evt.target.id, parseFloat(evt.target.value));
        const value = evt.target.value; 
        // اگر خالی بود، null یا undefined قرار بده، نه NaN
        if (value === '') {
            setFieldValue(evt.target.id, null);
            setSubmitting(false);
            return;
        }  
        const numberValue = parseFloat(value);
        // اگر عدد معتبر است ذخیره کن، در غیر این صورت null
        const finalValue = isNaN(numberValue) ? null : numberValue; 
        setFieldValue(evt.target.id, finalValue);
        setSubmitting(false);
      }

      const stringChangeHandler = (evt) => {
        setFieldValue(evt.target.id, evt.target.value);
      }

  return (
       <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            {/* هدر اطلاعات */}
            <div className="mb-4">
              <h3 className="fw-bold text-center">{carTitle}</h3>
              <div className="d-flex justify-content-center gap-3 mb-3">
                {/* <span className="badge bg-secondary">شناسه: {carId}</span> */}
                <span className="badge bg-info text-dark">عنوان سرویس: {operKindTitle}</span>
                <span className="badge bg-primary">نوع سرویس: {serviceType === "km" ? "کارکردی" : "زمانی"}</span>
              </div>
              <hr />
            </div>
  
            {/* فرم اصلی */}
            <form onSubmit={handleSubmit}>
              {/* فیلدهای مخفی */}
              <input value={carId} id="carId" type="hidden" readOnly />
              <input value={operKindId} id="operKindId" type="hidden" readOnly />
  
              {/* فیلد عنوان سرویس */}
              <div className="mb-3">
                <label htmlFor="opTitle" className="form-label">
                  عنوان سرویس
                </label>
                <input
                  value={values.opTitle}
                  onChange={stringChangeHandler}
                  id="opTitle"
                  type="text"
                  className={`form-control ${errors.opTitle && touched.opTitle ? 'is-invalid' : ''}`}
                  placeholder={operKindId === '90' || operKindId === '91' ? 'عنوان سرویس' : ''}
                />
              </div>
  
              {/* فیلد واحد */}
              <div className="mb-3">
                {serviceType === "km" ? (
                  <div className="form-floating">
                    <input
                      value={values.unit}
                      //onChange={stringChangeHandler}
                      id="unit"
                      type="text"
                      className={`form-control ${errors.unit && touched.unit ? 'is-invalid' : ''}`}
                      placeholder="unit"
                      readOnly
                    />
                    <label htmlFor="unit">واحد (کیلومتر)</label>
                    {errors.unit && touched.unit && (
                      <div className="invalid-feedback">{errors.unit}</div>
                    )}
                  </div>
                ) : (
                  <div className="form-floating">
                    <select
                      value={values.unit}
                      onChange={stringChangeHandler}
                      id="unit"
                      name="unit"
                      className={`form-select ${errors.unit && touched.unit ? 'is-invalid' : ''}`}
                    >
                      <option value="Y">سال</option>
                      <option value="m">ماه</option>
                      <option value="d">روز</option>
                    </select>
                    <label htmlFor="unit">واحد زمانی</label>
                  </div>
                )}
              </div>
  
              {/* فیلد دوره تکرار */}
              <div className="mb-3">
                <div className="form-floating">
                  <input
                    value={values.mtbo}
                    onChange={numberChangeHandler}
                    id="mtbo"
                    type="text"
                    inputMode="numeric"
                    className={`form-control ${errors.mtbo && touched.mtbo ? 'is-invalid' : ''}`}
                    placeholder="دوره تکرار"
                  />
                  <label htmlFor="mtbo">دوره تکرار</label>
                  {errors.mtbo && touched.mtbo && (
                    <div className="invalid-feedback">{errors.mtbo}</div>
                  )}
                </div>
              </div>
  
              {/* فیلد تاریخ آخرین انجام */}
              <div className="mb-3">
                <label htmlFor="lastDateG" className="form-label">
                  آخرین انجام در
                </label>
                <div className="libWrapper">
                    <DatePicker
                      inputClass={`form-control ${errors.lastDateG && touched.lastDateG ? 'is-invalid' : ''}`}
                      calendar={persian}
                      locale={persian_fa}
                      value={values.lastDateG || ""}
                      // onChange={setDate}
                      onChange={(value) => {
                        setFieldValue("lastDateG", value);
                      }}
                      format="YYYY/MM/DD"
                      calendarPosition="bottom-right"
                    />
                  {/* <DatePicker
                    defaultValue={calendarValue}
                    round="x4"
                    position="center"
                    id="lastDateG"
                    onChange={dateChangeHandler}
                    className={`form-control ${errors.lastDateG && touched.lastDateG ? 'is-invalid' : ''}`}
                  /> */}
                </div>
                {errors.lastDateG && touched.lastDateG && (
                  <div className="invalid-feedback">{errors.lastDateG}</div>
                )}
              </div>
  
              {/* فیلد کیلومتر آخرین انجام */}
                <div className="mb-3">
                  <div className="form-floating">
                    <input
                      value={values.lastKM}
                      onChange={numberChangeHandler}
                      id="lastKM"
                      type="text"
                      inputMode="numeric"
                      className={`form-control ${errors.lastKM && touched.lastKM ? 'is-invalid' : ''}`}
                      placeholder="آخرین کیلومتر انجام"
                    />
                    <label htmlFor="lastKM">آخرین کیلومتر انجام</label>
                    {errors.lastKM && touched.lastKM && (
                      <div className="invalid-feedback">{errors.lastKM}</div>
                    )}
                  </div>
                </div>
            
  
              {/* دکمه‌های اقدام */}
              <div className="d-flex justify-content-between mt-4">
                <button
                  className="btn btn-outline-primary px-4"
                  type="button"
                  onClick={beforeHandler}
                >
                  قبلی
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary px-4"
                >
                  {isSubmitting ? 'در حال ثبت...' : 'تایید'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
  )
}

export default ServiceStepThree